import React from 'react';
import { motion } from 'framer-motion';

const TestimonialSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="text-secondary uppercase tracking-wider font-semibold">Esperienze Vissute</span>
          <h2 className="text-4xl font-monomakh text-primary mt-2">La Voce dei Nostri Clienti</h2>
        </div>
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto bg-white p-12 rounded-lg shadow-lg relative"
        >
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-secondary text-white w-12 h-12 rounded-full flex items-center justify-center text-3xl font-serif">
            "
          </div>
          <p className="text-lg text-gray-600 mb-8 italic">
            "La nostra esperienza è stata molto positiva. Il titolare dell'agenzia e i collaboratori sono ragazzi giovani, educati, disponibili e professionali. Nel nostro caso Federico, il titolare, ha fatto un ottimo lavoro di mediazione e ci ha seguite con attenzione e scrupolo dalla proposta di acquisto al rogito."
          </p>
          <div className="flex items-center justify-center">
            <div>
              <h4 className="font-semibold text-primary">Emanuela Stolfi</h4>
              <p className="text-gray-500">Scandicci</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TestimonialSection;